// react
import React from "react"
// app
import DatePicker from "components/common/DatePicker"
import SelectField, { Style } from "containers/SelectField"
import TextField from "components/common/TextField"

export default ({
    onVisaChange,
    onDescriptionChange,
    onValidChange
}) =>
    <div className="clearfix">
        <h4>Add Visa</h4>
        <div className="float-left">
            <SelectField
                table="visa"
                label="Visa"
                mandatory={ true }
                style={ Style.ValueOnly }
                onChange={ onVisaChange }
            />
            <br />
            <DatePicker
                label="Valid Until"
                mandatory={ true }
                onChange={ onValidChange }
                value=""
            />
        </div>
        <div className="float-right">
            <TextField
                label="Description"
                onChange={ onDescriptionChange }
            />
        </div>
    </div>


/** WEBPACK FOOTER **
 ** ./src/components/person/Visas/add.js
 **/